// extracted by mini-css-extract-plugin
export default {"skeleton":"WalletCardSkeleton_skeleton__DzRIY"};